import type { TenderDocument } from "../../types"

import { isPlausibleDate } from "../../utils/deadline"

export function isIndexingPending(status: TenderDocument["status"]): boolean {
  return status === "uppladdad" || status === "indexeras"
}

export function procurementDocsReadyToStart(documents: TenderDocument[]): boolean {
  if (documents.length === 0) return false
  if (documents.some((doc) => isIndexingPending(doc.status))) return false
  return documents.some((doc) => doc.status === "indexerad")
}

export function documentsFinishedIndexing(documents: TenderDocument[]): boolean {
  return documents.length > 0 && !documents.some((doc) => isIndexingPending(doc.status))
}

/**
 * What committing the Setup "Sista dag för frågor" draft should do: nothing
 * (unchanged), save a value (a plausible date, or null to clear) or revert the
 * field. Years before 2000 are what a date input reports mid-typing (0002, 0202…).
 */
export function questionsDeadlineCommit(
  draft: string,
  current: string | null | undefined
): { kind: "noop" } | { kind: "save"; value: string | null } | { kind: "revert" } {
  if (draft === (current ?? "")) return { kind: "noop" }
  if (draft === "") return { kind: "save", value: null }
  if (isPlausibleDate(draft)) return { kind: "save", value: draft }
  return { kind: "revert" }
}
